import React from 'react'
import TransactionModal from './TransactionModal';
import CloseIcon from "../../../assets/svgs/closeIcon.svg"
// import CloseIcon from "@material-ui/icons/Close";
import useStyles from "./transactionModalStyles";
import { CircularProgress } from '@material-ui/core';
import BigNumber from "bignumber.js";
import millify from "millify";
import { supportedChains } from '../../../contract/constant';

function TransactionInProgress({transactionInProgress, setTransactionInProgress, chainId, value, height, claimItem}) {
  const classes = useStyles();
    return (
        <div>
                <TransactionModal open={transactionInProgress} height={"250px"}>
        <div>
          {/* <div>
            <img src={CloseIcon}
              // style={{
              //   display: "flex",
              //   marginLeft: "auto",
              //   fontWeight: "500",
              //   // transform: "scale(1.4)",
              //   cursor: "pointer",
              //   marginTop: "10px",
              // }}
              className={classes.closeIcon}
              onClick={() => {
                setTransactionInProgress(false);
              }}
            />
          </div> */}
          <div style={{ color: "#282828", textAlign: "center", paddingBottom:"20px" }}>
            <div style={{ padding: "30px" ,filter:"drop-shadow( 3px 3px 20px rgba(255, 223, 0, 0.7))"}}>
              <CircularProgress
                style={{ color: "#FFDF00", fontWeight: "900" }}
                size={60}
              />
            </div>
            <div
              style={{
                fontStyle: "normal",
                fontWeight: "800",
                fontSize: "20px",
                lineHeight: "25px",
                color: "#282828",
              }}
            >
              Transaction in Process
            </div>
            <div
              style={{
                paddingTop: "20px",
                fontFamily: "Inter",
                fontStyle: "normal",
                fontWeight: "500",
                fontSize: "16px",
                lineHeight: "140%",
                /* or 22px */

                textAlign: "center",

                color: "#696969",
              }}
            >
              Migrating your
              <br />{" "}
              <span style={{ fontWeight: "800", color: "#282828" }}>
                {" "}
                {parseFloat(value)
                &&(
                  (new BigNumber(parseFloat(value)).lt(1))?new BigNumber(parseFloat(value)).valueOf():millify(new BigNumber(parseFloat(value)).valueOf(), {
                    precision: 3,
                    lowercase: false,
                  }))
                  }{" "}
                MContent{" "}
              </span>{" "}
              from{" "}
              {(claimItem)?<span style={{ fontWeight: "600", color: "#282828" }}>
                {chainId === supportedChains[0] ? "BEP20" : "ERC20"}
              </span>:<span style={{ fontWeight: "600", color: "#282828" }}>
                {chainId === supportedChains[0] ? "ERC20" : "BEP20"}
              </span>}{" "}
              to{" "}
              {(claimItem)?(<span style={{ fontWeight: "600", color: "#282828" }}>
                {chainId === supportedChains[0] ? "ERC20" : "BEP20"}
              </span>):(<span style={{ fontWeight: "600", color: "#282828" }}>
                {chainId === supportedChains[0] ? "BEP20" : "ERC20"}
              </span>)}
            </div>
          </div>
        </div>
      </TransactionModal>
        </div>
    )
}

export default TransactionInProgress
